'use client';

import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import {
  AFFILIATE_QUERY_PARAMS,
  type AffiliateRegConfig,
  DEFAULT_REG_FORM_CONFIG,
  getGoogleOAuthAffiliateParams,
} from '../helpers/common';
import { useIsRegModalFlow } from './useIsRegModalFlow';

export function useAffiliateRegConfig(): AffiliateRegConfig {
  const params = useSearchParams();

  const regModal = useIsRegModalFlow();
  const shouldRedirectOnExit =
    params.get(AFFILIATE_QUERY_PARAMS.redirectOnClose) === 'true';
  const shouldHideExitPopup =
    params.get(AFFILIATE_QUERY_PARAMS.withoutExitPopup) === 'true';
  const newTerms = params.get(AFFILIATE_QUERY_PARAMS.newTerms) === 'true';
  const oneTerms = params.get(AFFILIATE_QUERY_PARAMS.oneTerms) === 'true';
  const autoCheck = params.get(AFFILIATE_QUERY_PARAMS.autoCheck) === 'true';
  const googleAuth = params.get(AFFILIATE_QUERY_PARAMS.googleAuth) === 'true';
  const regModalTheme = params.get(AFFILIATE_QUERY_PARAMS.regModalTheme);

  return useMemo<AffiliateRegConfig>(() => {
    if (!regModal)
      return getGoogleOAuthAffiliateParams() ?? DEFAULT_REG_FORM_CONFIG;

    return {
      regModalTheme,
      shouldHideExitPopup,
      shouldRedirectOnExit,
      newTerms,
      oneTerms,
      autoCheck,
      googleAuth,
    };
  }, [
    regModalTheme,
    shouldRedirectOnExit,
    shouldHideExitPopup,
    newTerms,
    oneTerms,
    autoCheck,
    regModal,
    googleAuth,
  ]);
}
